import { createContext } from 'react';
import {
    AddressType,
    DealerAddressType,
    ProductType,
    UploadedDocument,
    VehicleType
} from '../components/common/CommonTypes';
import { ProgressBarItem } from '../components/common/progressBar/ProgressBar';
import {
    TyrePageState,
    TyreProcessStages
} from '../components/sitePages/tyreRepairRequest/TyreRepairRequestTypes';

export type TyreRepairRequestContextState = {
    product: ProductType;
    vehicle: VehicleType;
    progressBarItems: ProgressBarItem[];
    tyreRepairRequest: TyrePageState;
    onChangeMileage: (value: string) => void;
    onChangeRepairOption: (value: string) => void;
    onTyreValueChange: (key: string, value: string) => void;
    onTyreRepairRequestChangeTyre: (value: string, key: string) => void;
    onTyreSelected: (tyre: string) => void;
    onChangeDamageType: (selectionName: string) => void;
    onRepairAddressSelectionChanged: (selectedIndex: number) => void;
    onDealerAddressUpdate: (dealerAddres: DealerAddressType) => void;
    onGarageAddressUpdate: (dealerAddres: AddressType) => void;
    onUploadImageChange: (
        imageType: string,
        uploadedPath: string,
        imageId: string,
        image: string,
        filename: string
    ) => void;
    onInvoiceChange: (invoice: UploadedDocument) => void;
    onTogglePermission: (isChecked: boolean) => void;
    onFinishedTyreRepairRequest: () => void;
    onCancelClick: () => void;
    onCancelRepairRequest: () => void;
    onCancelUndo: () => void;
    onChangeStage: (stage: TyreProcessStages) => void;
    onUpdateTyreClick: (tyre: string) => void;
    onUpdateAddressClick: (scrollToAddress: boolean) => void;
    onContinueRepairRequest: () => void;
    onContinueToRepairAddress: () => void;
    onFinishAddingTyres: () => boolean;
    onDeleteRepairRequest: (tyre: string) => void;
    onChangDateOfIncident: (value: string) => void;
    onDefaultDealerAddressUpdate: (defaultDealerAddress: AddressType) => void;
    onClearTyreRepairRequests: () => void;
};

const initialState = {} as TyreRepairRequestContextState;

export const TyreRepairRequestContext = createContext(initialState);
